import {
  CartSplitPolicy,
  OrderDraft,
  OrderType,
  SplitConfiguration,
  SplitMode
} from '@features/sales/domain/models/order/order-split.model';
import { Cart } from '@features/sales/domain/entities/cart/cart.entity';
import { CartItemDTO } from '@features/sales/domain/models/cart/cart-item.model';

export class RedemptionSplitPolicy implements CartSplitPolicy {
  supports(config: SplitConfiguration): boolean {
    return config.mode === SplitMode.BY_REDEMPTION;
  }

  partition(cart: Cart): OrderDraft[] {
    const items = cart.toDTOs();

    if (!this.hasAddons(items)) {
      return this.single(OrderType.REDEMPTION, items);
    }

    const saleItems = items.filter(item => this.hasPriceableAddons(item));
    const redemptionItems = items.filter(item => !this.hasPriceableAddons(item));

    if (!saleItems.length) {
      return this.single(OrderType.REDEMPTION, items);
    }

    return [
      { type: OrderType.SALE, items: saleItems },
      { type: OrderType.REDEMPTION, items: redemptionItems },
    ];
  }

  private hasAddons(items: CartItemDTO[]): boolean {
    return items.some(item => this.hasPriceableAddons(item));
  }

  private hasPriceableAddons(item: CartItemDTO): boolean {
    return !!item.additionalProduct && item.additionalProduct.price > 0;
  }

  private single(type: OrderType, items: CartItemDTO[]): OrderDraft[] {
    return [{ type, items }];
  }
}
